import { render, staticRenderFns } from "./MerchantStaffKycUpdate.vue?vue&type=template&id=d57f5f44"
import script from "./MerchantStaffKycUpdate.vue?vue&type=script&lang=js"
export * from "./MerchantStaffKycUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports